import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'index',
		redirect: '/index',
		component: () => import('../views'),
		children: [
			{
				path: '/index',
				name: 'Home',
				component: () => import('../views/home'),
				meta: { title: "首页" }
			},
			{
				path: '/news',
				name: 'News',
				component: () => import('../views/news'),
				meta: { title: "新闻动态" }
			},
			{
				path: '/news/:id',
				name: 'NewsInfo',
				component: () => import('../views/news/info'),
				meta: { title: "新闻动态-详情" }
			},
			{
				path: '/about',
				name: 'About',
				component: () => import('../views/about'),
				meta: { title: "关于我们" }
			},
			{
				path: '/work',
				name: 'Work',
				component: () => import('../views/work'),
				meta: { title: "业务介绍" }
			},
			{
				path: '/recruit',
				name: 'Recruit',
				component: () => import('../views/recruit'),
				meta: { title: "诚聘英才" }
			},
			{
				path: '/contact',
				name: 'Contact',
				component: () => import('../views/contact'),
				meta: { title: "联系我们" }
			},
			{
				path: '/notice/:id',
				name: 'NoticeInfo',
				component: () => import('../views/notice/info'),
				meta: { title: "通知公告-详情" }
			},
		]
	},

	{
		path: '/empty/phone',
		name: 'EmptyPhone',
		component: () => import('../views/error/phone'),
	},
	{
		path: "*",
		component: () => import('../views/error/404')
	}
]

//重写push，避免冗余导航报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
	// mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router
